import { Head, Link } from "@inertiajs/react";
import { Badge, Box, Card, Flex, Text } from "@radix-ui/themes";
import ManagerPageHeader from "@/shared/manager/ManagerPageHeader";
import type { BrandsIndexProps } from "@/types/brands_index";

// Only reached with several brands (one goes straight to its edit page) or
// none — by URL, since the sidebar hides the link until there's one.
export default function BrandsIndex({ brands }: BrandsIndexProps) {
  return (
    <>
      <Head title="Branding" />
      <Box className="w-full">
        <ManagerPageHeader title="Branding" />
        <Box px={{ initial: "3", sm: "4" }} py="3" className="max-w-3xl">
          {brands.length === 0 ? (
            <Text as="p" color="gray">
              A branded site — your name, colours and logo on your own domain — is an add-on. Get in
              touch with Driftables to set one up.
            </Text>
          ) : (
            <Flex direction="column" gap="3">
              {brands.map((brand) => (
                <Card key={brand.id} asChild>
                  <Link href={brand.edit_path}>
                    <Flex justify="between" align="center" gap="3">
                      <Flex direction="column" gap="1">
                        <Text weight="bold">{brand.name}</Text>
                        <Text size="2" color="gray">{brand.owner_name}</Text>
                      </Flex>
                      <Badge variant="soft" color="gray">{brand.owner_kind}</Badge>
                    </Flex>
                  </Link>
                </Card>
              ))}
            </Flex>
          )}
        </Box>
      </Box>
    </>
  );
}
